import * as React from "react"
import { ChevronDown } from "lucide-react"

import { cn } from "@/lib/utils"

interface PeriodFilterOption<TValue extends string> {
  value: TValue
  label: React.ReactNode
}

interface PeriodFilterSelectProps<TValue extends string> {
  value: TValue
  options: readonly PeriodFilterOption<TValue>[]
  onValueChange: (value: TValue) => void
  className?: string
  selectClassName?: string
  "aria-label"?: string
}

const PeriodFilterSelect = <TValue extends string>({
  value,
  options,
  onValueChange,
  className,
  selectClassName,
  "aria-label": ariaLabel,
}: PeriodFilterSelectProps<TValue>) => (
  <div className={cn("relative", className)}>
    <select
      aria-label={ariaLabel}
      value={value}
      onChange={(event) => onValueChange(event.target.value as TValue)}
      className={cn(
        "h-9 w-full cursor-pointer appearance-none border border-border bg-background px-3 py-2 pr-8 text-xs font-bold uppercase tracking-widest text-foreground transition-colors focus:border-primary focus:outline-none sm:w-auto",
        selectClassName
      )}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
    <ChevronDown
      aria-hidden="true"
      className="pointer-events-none absolute right-2 top-1/2 size-3.5 -translate-y-1/2 text-muted-foreground"
    />
  </div>
)

export { PeriodFilterSelect, type PeriodFilterOption }
